module.exports = __webpack_public_path__ + "img/outside-temperature-sm.c353b20c.svg";